// Theme configuration:
export const MuiIconButton = {
    styleOverrides: {
        sizeSmall: {
            padding: "5px",
            fontSize: "12px",
            width: "24px",
            height: "24px"
        },
        sizeMedium: {
            padding: "8px",
            fontSize: "16px",
            width: "32px",
            height: "32px"
        },
        sizeLarge: {
            padding: "10px",
            fontSize: "16px",
            width: "36px",
            height: "36px"
        }
    },
    variants: [
        {
            props: { color: "default" },
            style: ({ theme }) => ({
                "&:hover:not(.Mui-disabled)": {
                    color: theme.palette.primary.main,
                    backgroundColor: theme.palette.action.hover
                }
            })
        }
    ]
};
//# sourceMappingURL=IconButton.js.map